import { useSelector } from 'react-redux'
import { isAddStepMenuOpenForPath } from '../selectors'
import { RootState } from '../../../reducers'

export const useIsAddStepMenuOpenForPath = (path: string) => {
  return useSelector((s: RootState) => isAddStepMenuOpenForPath(s, path))
}
